<template>
  <div>
    <px-view-header title="Projetos" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-projeto-list-header :on-click-refresh="onClickRefresh"
                            :on-change-filter="onChangeFilter"/>
    <px-projeto-list :projetos="projetos"
                     :loading="loading"
                     :on-change-options="onChangeOptions"
                     :options-list="optionsList"
                     @remove="onRemove"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import ProjetoService from './projeto-service';
import ProjetoList from './ProjetoList.vue';
import ProjetoListHeader from './ProjetoListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Projetos' },
      ],
      projetos: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'descricao',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemProjetos', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getProjetos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getProjetos();
    },
    onClickRefresh() {
      this.getProjetos();
    },
    onRemove(item) {
      this.loading = true;
      ProjetoService.remover(item.id)
        .then(() => {
          this.$toast('projeto removido com sucesso', { color: 'success' });
          this.getProjetos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getProjetos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return ProjetoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.projetos = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxProjetoList: ProjetoList,
    pxProjetoListHeader: ProjetoListHeader,
  },
};

</script>
